import React from 'react';
import {Link} from 'react-router';
import './ReviewTypeBreadcrumbs.styl';

export default class ReviewTypeBreadcrumbs extends React.Component {
  render() {
    const {reviewType} = this.props;
    return (
      <div className="breadcrumbs review-type-breadcrumbs">
        <Link className="generic-link" to={'/admin/sessionTypes'}>
          Coaching Meeting Types
        </Link>
        {reviewType.id ? (
          <span>/ {reviewType.name}</span>
        ) : (
          <span>/ Create New Coaching Meeting Type</span>
        )}
      </div>
    );
  }
}
